module.exports = __webpack_public_path__ + "podcast_vikatan_menu-5bbfdbc086bb8069277c.svg";